{
  "tabs": {
    "chat": "Puisano",
    "reminders": "Dikgopotso",
    "calendar": "Khalendara",
    "settings": "Dikgato"
  },
  "common": {
    "cancel": "Iteele",
    "save": "Boloka",
    "confirm": "Netefatsa",
    "delete": "Swinya",
    "back": "Tsela morago",
    "close": "Tsaya",
    "edit": "Sebelisa",
    "search": "Batla",
    "all": "Tsona",
    "loading": "Go laela...",
    "error": "Go na le phoso",
    "notFound": "Ga go a fitlhelwa",
    "tryAgain": "Lekang gape",
    "retry": "Lekang gape",
    "undo": "Tlosa",
    "pullToRefresh": "Goga go ntsha gape",
    "justNow": "Mo nakong e e fetileng"
  },
  "auth": {
    "welcome": "Amogela mo FishMemory",
    "tagline": "Mothusi wa gago wa dikgopotso tsa WhatsApp, jaanong mo poketeng ya gago.",
    "subtitle": "Mothusi wa gago wa dikgopotso tsa WhatsApp, jaanong mo poketeng ya gago.",
    "phoneLabel": "Nomoro ya gago ya WhatsApp",
    "phoneHint": "Re tla romela khoutu ya netefatso ka WhatsApp",
    "invalidPhone": "Tsaya nomoro ya mogala e e siameng",
    "continue": "Tswelela",
    "enterPhone": "Tsaya nomoro ya gago ya WhatsApp",
    "phonePlaceholder": "Nomoro ya mogala",
    "sendCode": "Romela Khoutu",
    "verifyTitle": "Netefatsa nomoro ya gago",
    "otpSentTo": "Khoutu ya digiti tse 6 e rometswe go {{phone}} ka WhatsApp",
    "enterFullCode": "Tsaya digiti tsotlhe tse 6",
    "invalidOtp": "Khoutu e sa siamang. Lekang gape.",
    "otpFailed": "Go paletswe go romela khoutu. Lekang gape.",
    "otpResent": "Khoutu e rometswe gape",
    "resendIn": "Romela gape mo go {{seconds}}s",
    "resendCode": "Romela khoutu gape",
    "enterOtp": "Tsaya khoutu e e rometsweng go WhatsApp ya gago",
    "verify": "Netefatsa",
    "resend": "Romela khoutu gape",
    "wrongNumber": "Nomoro e phoso?",
    "backToPhone": "Tsela morago go mogala",
    "editPhone": "Sebelisa nomoro ya mogala",
    "error": "Phoso",
    "setupTitle": "A re simololeng",
    "setupSubtitle": "O ka fetola tse fa morago mo Dikgatong",
    "namePlaceholder": "Leina la gago",
    "letsGo": "Fetola dikgatso",
    "skipForNow": "Tlola jaanong"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kwala molaetsa...",
    "inputPlaceholder": "Kwala molaetsa...",
    "typing": "FishMemory e kwalela...",
    "online": "Inthaneteng",
    "connecting": "Go kopanya...",
    "reconnecting": "Go kopanya gape...",
    "offline": "Ga a Inthaneteng",
    "empty": "Simolola puisano",
    "emptyHint": "Dira dikgopotso, lekola lenane la gago, kgotsa kopa thuso.",
    "emptyAction": "Romela kgopotso ya sekai",
    "actions": "Ditiro tsa puisano",
    "keep": "Boloka melaetsa",
    "clearTitle": "Tlosa puisano",
    "clearConfirm": "A o batla go swinya melaetsa yotlhe mo sesebediswa seno? Ga go kgone go boela morago.",
    "clear": "Tlosa puisano",
    "optionSelected": "E kgethilwe: {{label}}",
    "sendingSelection": "E romelwa...",
    "connectionLost": "Go kopanya gape..."
  },
  "reminders": {
    "title": "Dikgopotso Tsa Me",
    "active": "E a diragala",
    "today": "Gompieno",
    "thisWeek": "Beke eno",
    "history": "Histori",
    "items": "dintho",
    "emptyTitle": "Ga go na dikgopotso",
    "emptySubtitle": "Dira nngwe mo puisanong mme e tla bonwa fa.",
    "emptyAction": "Bula puisano",
    "filterActive": "E a diragala",
    "filterToday": "Gompieno",
    "filterWeek": "Beke eno",
    "filterHistory": "Histori",
    "emptyState": "Ga go na dikgopotso. Simolola go bua!",
    "swipeDone": "E dirilwe",
    "swipeSnooze": "Tsosolosa",
    "swipeDelete": "Swinya",
    "search": "Batla dikgopotso...",
    "upcoming": "E tlang",
    "completed": "E dirilwe",
    "overdue": "E fetileng nako",
    "tomorrow": "Letsatsi le le tlang",
    "synced": "E tsamaellanitswe {{value}}",
    "swipeHint": "Swaya kgopotso go bona ditiro tse dingwe",
    "noResults": "Ga go na dikgopotso tse di tshwanelang patoloso ya gago",
    "noResultsHint": "Lekang lefoko le le farologaneng kgotsa tlosa patoloso",
    "deleteAllFailed": "Go paletswe go swinya dikgopotso tsotlhe"
  },
  "calendar": {
    "title": "Khalendara",
    "today": "Gompieno",
    "tomorrow": "Letsatsi le le tlang",
    "completed": "e dirilwe",
    "noEvents": "Ga go na ditiragalo",
    "noEventsSubtitle": "Kgetha letsatsi go bona dikgopotso le ditiragalo tsa khalendara.",
    "googleEvent": "Khalendara ya Google",
    "legendActive": "E a diragala",
    "legendRecurring": "E boela gape",
    "legendDone": "E dirilwe",
    "legendGoogle": "Google",
    "previousMonth": "Kgwedi e e fetileng",
    "nextMonth": "Kgwedi e e tlang",
    "previousYear": "Ngwaga o o fetileng",
    "nextYear": "Ngwaga o o tlang",
    "goToToday": "Ya gompieno",
    "all": "Tsona",
    "active": "E a diragala",
    "done": "E dirilwe",
    "paused": "E eme"
  },
  "settings": {
    "title": "Dikgato",
    "profile": "Profilo",
    "name": "Leina la Pontsho",
    "enterName": "Tsaya leina la gago",
    "language": "Puo",
    "uiLanguage": "Puo ya app",
    "uiLanguageHelp": "E fetola puo ya app, mabitso a khalendara, le tsela ya go tlhama mo sesebedisong seno fela.",
    "serverLanguage": "Puo ya puisano",
    "serverLanguageHelp": "E fetola puo e e dirisiwang ke dikarabo tsa seva le melaetsa ya dikgopotso mo akhaonteng ya gago.",
    "timezone": "Nako ya setšhaba",
    "currentTimezone": "Nako ya setšhaba ya jaanong",
    "timezoneHelp": "Dintlha tsotlhe tsa dikgopotso di bontshwa ka nako eno ya setšhaba.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Boloka nako ya setšhaba",
    "timezoneSaved": "Nako ya setšhaba e fetotswe",
    "detect": "Bona",
    "detectFailed": "Ga go a kgonega go bona nako ya setšhaba",
    "autoDetect": "Bona ka GPS",
    "notifications": "Ditsebiso",
    "notificationsHelp": "Dikgopotso tse di latelang di laola ditsebiso tse di boelang morago ga kgopotso. Ditshwanelo tsa ditsebiso mo sesebedisong di laolwa mo dikgatong tsa mogala wa gago.",
    "pushEnabled": "Ditsebiso tse di tsosang",
    "autoDoneOnFire": "Iketsetse e dirilweng fa e tsositswe",
    "autoDoneOnFireDesc": "Fa e tlositswe, dikgopotso di nna di le teng go fitlha o di supa e le tse di dirilweng.",
    "googleCalendar": "Khalendara ya Google",
    "google": "Khalendara ya Google",
    "googleConnected": "E kopantswe",
    "googleDisconnected": "Ga e kopantswe",
    "googleConnectedHelp": "Dikgopotso tse disha di ka tsamaellanwa le khalendara ya gago ka boikgethelo.",
    "googleDisconnectedHelp": "Kopanya Khalendara ya Google go tsweletsa dikgopotso le ditiragalo.",
    "googleConnectFailed": "Go paletswe go kopanya Khalendara ya Google",
    "connected": "E kopantswe",
    "disconnected": "Ga e kopantswe",
    "connect": "Kopanya",
    "disconnect": "Tlosetsa",
    "autoSync": "Tsamaellanisa dikgopotso tse disha ka boikgethelo",
    "autosync": "Tsamaellanisa dikgopotso tse disha ka boikgethelo",
    "subscription": "Ngodiso",
    "trialUsed": "Tlhahlobo: {{used}}/{{total}} e dirisiwe",
    "trialStatus": "Tlhahlobo e teng",
    "activeStatus": "Ngodiso e a diragala",
    "expiredStatus": "Ngodiso e fedile",
    "unsubscribedStatus": "Ga o ngodisitswe",
    "about": "Ka ga",
    "version": "Phetolelo",
    "logout": "Tsamaela kwa ntle",
    "logoutTitle": "Tsamaela kwa ntle",
    "logoutConfirm": "A o na le tshwanelo ya go tsamaela kwa ntle?",
    "noName": "Ga go leina le le setilweng",
    "serverConnection": "Kgokagano ya seva",
    "serverUrl": "URL ya seva",
    "serverEdit": "Sebelisa",
    "saveReconnect": "Boloka o kopanye gape",
    "resetDefault": "Bula boemo jwa ntlha",
    "invalidServerUrlTitle": "URL ya seva e sa siamang",
    "invalidServerUrlMessage": "Tsaya URL ya seva e e siameng ya http kgotsa https, mohlala https://example.com",
    "uiLanguageChangeFailed": "Go paletswe go fetola puo ya app. Lekang gape.",
    "serverLanguageChangeFailed": "Go paletswe go fetola puo ya puisano. Lekang gape.",
    "timezoneChangeFailed": "Go paletswe go fetola nako ya setšhaba. Lekang gape.",
    "autoSyncChangeFailed": "Go paletswe go fetola tsamaellaniso ya boikgethelo. Lekang gape.",
    "nameChangeFailed": "Go paletswe go fetola leina la pontsho. Lekang gape.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Dintlha tsa kgopotso",
    "editTime": "Sebelisa Nako",
    "rename": "Fetola leina",
    "snooze": "Tsosolosa",
    "snooze15": "Tsosolosa metsotso e 15",
    "pause": "Emisa",
    "pauseReminder": "Emisa kgopotso",
    "resume": "Tsweletsa",
    "resumeReminder": "Tsweletsa kgopotso",
    "skip": "Tlola e e latelang",
    "skipOccurrence": "Tlola ketsahalo eno",
    "syncGoogle": "Tsamaellanisa le Google",
    "delete": "Swinya",
    "deleteTitle": "Swinya Kgopotso",
    "deleteConfirm": "Kgopotso e tla swinywa ka go sa khutliswe morago.",
    "deleteRecurringTitle": "Swinya Kgopotso e e Boelang",
    "deleteRecurringMessage": "A o batla go tlola ketsahalo eno kgotsa go swinya letoto lotlhe?",
    "deleteThisOccurrence": "Tlola Ketsahalo Eno",
    "deleteEntireSeries": "Swinya Letoto Lotlhe",
    "done": "E dirilwe",
    "markDone": "Supaya e le e dirilweng",
    "undo": "Busetsa morago",
    "undoPrompt": "A o batla e boe e le teng? E busetsa morago jaanong.",
    "recurring": "E boela gape",
    "nextRun": "E latelang",
    "oneTime": "Nako e le nngwe",
    "pending": "E emetse",
    "sent": "E rometswe",
    "paused": "E eme",
    "active": "E a diragala",
    "snoozed": "E tsosolositse",
    "localTime": "E bontshitswe ka nako ya mo lefelong la gago",
    "recurrence": "Boela gape",
    "created": "E dirilwe",
    "tags": "Ditlhaka",
    "fireCount": "Makgetho a a tsositsweng",
    "actions": "Ditiro",
    "none": "Ga gona",
    "snoozeFailed": "Go paletswe go tsosolosa kgopotso",
    "pauseFailed": "Go paletswe go emisa kgopotso",
    "resumeFailed": "Go paletswe go tsweletsa kgopotso",
    "skipFailed": "Go paletswe go tlola kgopotso",
    "doneFailed": "Go paletswe go supa kgopotso e le e dirilweng",
    "undoFailed": "Go paletswe go busetsa maemo a kgopotso morago",
    "deleteFailed": "Go paletswe go swinya kgopotso",
    "rescheduleTitle": "A o batla go fetola nako?",
    "rescheduleMsg": "Kgopotso eno e feta nako. A o batla go e fetola?",
    "reschedule15": "Mo metsotsong e 15",
    "reschedule60": "Mo ura e le nngwe",
    "keepOverdue": "E tlogele jaaka e le"
  },
  "onboarding": {
    "slide1Title": "Amogela mo FishMemory",
    "slide1Sub": "Mothusi wa gago wa dikgopotso - o tsamaisiwa ke WhatsApp mme o dirilwe go fitlha mo poketeng ya gago.",
    "slide2Title": "Bua ka tlhago",
    "slide2Sub": "Kwala dikgopotso jaaka o akanya: \"Gopotse go letsetsa mma ka letsatsi le le tlang ka 3pm\" — re dira tse dingwe.",
    "slide3Title": "O se ka wa fosa selo",
    "slide3Sub": "Fumana ditsebiso ka nako, rulaganya ka ditlhaka, o nne o itse tsotlhe tse di botlhokwa.",
    "getStarted": "Simolola",
    "next": "E latelang",
    "firstReminderTitle": "Dira kgopotso ya gago ya ntlha!",
    "firstReminderHint": "Lekang go kwala sengwe jaaka:",
    "firstReminderExample": "Gopotse go nwa metsi ka letsatsi le le tlang ka 9 AM",
    "gotIt": "Ke a tlhaloganya!",
    "notifRationaleTitle": "Nna mo nakong",
    "notifRationaleBody": "FishMemory e tlhoka ditsebiso go go gopotsetsa ka nako. O tla bona ditsebiso fela tsa dikgopotso tse o di dirileng.",
    "notifRationaleAllow": "Dira Ditsebiso",
    "notifRationaleLater": "Mma morago",
    "swipeHint": "Swaya kwa go le gaufi go dira ditiro tse di potlakileng →",
    "calendarDragHint": "Tshwara o gogele go atolosa ↕"
  }
}
